import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-create-failed',
  templateUrl: './create-failed.component.html',
  styleUrls: ['./create-failed.component.scss']
})
export class CreateFailedComponent implements OnInit {
  @Input() routeName: string;
  @Input() projectName: string;
  @Output() onToRouteOverviewClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() onToProjectOverviewClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() onNewRouteClicked: EventEmitter<void> = new EventEmitter<void>();


  constructor() { }

  ngOnInit() {
  }

  routeOverviewClicked(): void {
    this.onToRouteOverviewClicked.emit();
  }

  projectOverviewClicked(): void {
    this.onToProjectOverviewClicked.emit();
  }

  newRouteClicked(): void {
    this.onNewRouteClicked.emit();
  }

  hasProject(): boolean {
    if (this.projectName) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/new-route/components/create-failed/create-failed.component.ts